import { yupResolver } from "@hookform/resolvers/yup";
import { AlertColor } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import ButtonGeneric from "../../components/ButtonGeneric";
import InputGeneric from "../../components/InputGeneric";
import PageWrapper from "../../components/PageWrapper/index";
import PreloadButton from "../../components/PreloadButton";
import Toast from "../../components/Toast";
import { useAuth } from "../../contexts/contexts";
import { api } from "../../services/api";
import { FormReminderSettingPage } from "./styles";

type reminderSettingFormTypeValues = {
    reminderDate: string;
};

const reminderSettingFormSchema = yup.object().shape({
    reminderDate: yup.string().required(),
});

function ReminderSettingPage() {
    const navigate = useNavigate();
    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            hasPermissions("configuracao.lembrete.cadastrar") === false &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<reminderSettingFormTypeValues>({
        resolver: yupResolver(reminderSettingFormSchema),
    });

    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const createNewReminderSetting: SubmitHandler<
        reminderSettingFormTypeValues
    > = async (formValues) => {
        setIsLoadingButton(true);
        api.post(`/reminders`, {
            reminder_date: formValues.reminderDate,
        })
            .then((response) => {
                setOpenToast(true);
                setToastRequisitionResult("success");
                setTextToast(response.data.message);
            })
            .then(() => {
                setTimeout(() => {
                    setOpenToast(false);
                    setIsLoadingButton(false);
                }, 2000);
            })
            .catch((response) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(response.response.data.response.name);
                setIsLoadingButton(false);
            });
    };

    return (
        <PageWrapper>
            <FormReminderSettingPage>
                <div className="topFormPage">
                    <h2>Tempo em Dias para lembrete de formulário</h2>
                </div>
                <form onSubmit={handleSubmit(createNewReminderSetting)}>
                    <div className="inputsContainer">
                        <Controller
                            control={control}
                            name="reminderDate"
                            render={({
                                field: { onChange, onBlur, value = "", ref },
                            }) => (
                                <InputGeneric
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    type="number"
                                    size="small"
                                    className="inputs"
                                    label="Digite o tempo em dias"
                                    error={!!errors.reminderDate}
                                    ref={ref}
                                    autoFocus
                                    inputProps={{ min: 1 }}
                                />
                            )}
                        />
                    </div>
                    <div className="buttonsContainer">
                        <ButtonGeneric
                            onclick={() => navigate("/home")}
                            buttonColor="var(--cancel)"
                            text="VOLTAR"
                        />
                        <PreloadButton
                            colorText="white"
                            background="var(--confirm)"
                            loading={isLoadingButton}
                            text="CONFIRMAR"
                            type="submit"
                        />
                    </div>
                </form>
                <Toast
                    open={openToast}
                    onClose={() => handleCloseToast()}
                    severity={toastRequisitionResult}
                    text={textToast}
                />
            </FormReminderSettingPage>
        </PageWrapper>
    );
}
export default ReminderSettingPage;
